import React from 'react';
import CodeBlock from '../../atoms/CodeBlock';
import { Table } from '../../atoms/Table';

// Extract language from className (e.g., "language-python" -> "python")
const extractLanguage = (className?: string): string | undefined => {
  if (!className) return undefined;
  const match = className.match(/language-(\w+)/);
  return match ? match[1] : undefined;
};

// Custom pre component that wraps CodeBlock
const Pre = (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLPreElement>, HTMLPreElement>) => {
  const { children, className } = props;
  
  // Check if children is a code element (MDX structure)
  if (React.isValidElement(children) && children.props?.className?.includes('language-')) {
    const language = extractLanguage(children.props.className);
    
    return (
      <CodeBlock language={language} className={className}>
        {children.props.children}
      </CodeBlock>
    );
  }

  // Fallback to CodeBlock with no language for plain code blocks
  return (
    <CodeBlock language={undefined} className={className}>
      {children}
    </CodeBlock>
  );
};

// Custom code component for inline code
const Code = (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>) => {
  const { children, className } = props;
  
  // If this is a block code (has language class), let Pre handle it
  if (className?.includes('language-')) {
    return <code className={className}>{children}</code>;
  }

  // Inline code styling
  return (
    <code className="bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-1.5 py-0.5 rounded text-sm font-mono">
      {children}
    </code>
  );
};



export const MDXComponents = {
  pre: Pre,
  code: Code,
  Table,
};

export default MDXComponents;